import request from './request'

const api = {
  getDataByUrl(url) {
    return request.get(url)
  }
}

export default api